import clsx from "clsx";
import Image from "components/Elements/Image/Image";
import Button from "components/Elements/Button/Button";
import Authentication from "../..";

import { type Dispatch, memo, type SetStateAction } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import type { AuthModalTypeT } from "../../models/models";

import styles from "./signUpBanner.module.scss";

interface SignUpBannerI extends React.HTMLAttributes<HTMLDivElement> {
  setModalType: Dispatch<SetStateAction<AuthModalTypeT>>;
}

const SignUpBanner = memo((props: SignUpBannerI) => {
  const { className, setModalType, ...restProps } = props;

  const { getTextByKey } = useContent();

  const handleOpenSignUp = () => {
    setModalType("sign-up");
  };

  return (
    <div className={clsx(styles.wrapper, className)} {...restProps}>
      <Image name="paper-plane-circled-white" className={styles.planeImage} />
      <h1>{getTextByKey("create-new-account-title")}</h1>
      <p>{getTextByKey("create-new-account-subtitle")}</p>
      <Button onClick={handleOpenSignUp}>
        {getTextByKey("create-new-account-button")}
      </Button>
    </div>
  );
});

export default SignUpBanner;
